export default __webpack_public_path__ + "static/media/ApplianceGuideCover_use.a60ff37c.png";